var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm main-gallery"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('tit-primary', [_vm._v("갤러리")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "main-gallery__more-btn",
    attrs: {
      "to": "/edu-gallery"
    }
  }, [_c('txt-primary', {
    staticClass: "txt--sm"
  }, [_vm._v("MORE"), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")])])], 1)], 1)], 1), _c('div', {
    staticClass: "board-list"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.galleries, function (gallery, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('dialog-secondary', {
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var attrs = _ref.attrs,
            on = _ref.on;
          return [_c('div', _vm._g(_vm._b({
            staticClass: "board-list__item"
          }, 'div', attrs, false), on), [_c('v-img', {
            attrs: {
              "src": gallery.image,
              "aspect-ratio": 282 / 211,
              "cover": "",
              "alt": gallery.subject
            }
          })], 1)];
        }
      }], null, true)
    }, [_c('v-img', {
      attrs: {
        "src": gallery.image,
        "alt": gallery.subject
      }
    })], 1)], 1);
  }), 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }